/** Plan/subscription feature that unlocks social publishing and the calendar. */
export const SOCIAL_PUBLISHING_FEATURE = 'social_publishing';

export function hasSocialPublishingFeature(features: unknown): boolean {
  return Array.isArray(features) && features.includes(SOCIAL_PUBLISHING_FEATURE);
}
